export const setActiveCaseRun = (
  caseRuns: CMxAPI.CaseRun[],
  processId: number
) => {
  return caseRuns.find(caseRun => {
    return caseRun.process_instance_id === processId;
  });
};
